import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import { TreeSelect } from "primereact/treeselect";
import { FileUploader } from "react-drag-drop-files";
import Select from "react-select";
import { EditorState, convertToRaw, ContentState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import AOS from "aos";
import axios from "axios";
import "aos/dist/aos.css";
import { moduleTagCategoryWithTags, createNewCustomTags, resourcePlatforms } from "../utils";
import { usePageTitle } from "../PageTitleContext";
import { AddIcon, DeleteIcon, GalleryIcon } from "../../Static/icons/iconshere";
import { FormControl, RadioGroup, Radio, FormControlLabel } from "@mui/material";
import { BtnLoading } from "../../animations/BtnLoading";
import { toastError } from "../../utils/toast";
import { debounce, verifyImageResolution } from "../../utils/useWindowDimensions";
import apiClient from "../../apiClient";
import {
  XR_MODULE_DETAIL,
  LINKED_ASSET_LIST,
  CONNECT_ASSETS,
  CATEGORY_ASSETS_LIST,
  CATEGORY_CHILDREN_LIST,
  RESOURCE_TYPE_APPLICATION,
} from "../../apiClient/apiEndpoints";
import LinkModal from "../LinkModal";
import { addReviewModuleData } from "../../store/slice/moduleSlice";
import MediaGalleryModal from "./MediaGalleryModal";
import { CategoryFilterId } from "../../env";
import { transformData, isFileSizeOverMaxSize, getAllowedMaxFileSize } from "../../utils/common";
import QRExpand from "./QRExpand";
import { imageFileTypes } from "../../utils/constants";
import { MODULE_MEDIA_SIZE, MODULE_THUMBNAIL_SIZE } from "../../constant/limitSize";
import { VALUE } from "../../constant/constant";

let availablePlatformList = resourcePlatforms.map(({ name, key }) => ({
  label: name,
  value: key,
}));


const Details = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const locationData = useLocation();
  const actionMode = locationData?.state?.actionMode || "XR";
  const type = locationData?.state?.type || "MODULE";
  if (!actionMode || !type) navigate("/dashboard/xr");
  const moduleUUID = params.uuid;
  const configData = useSelector((state) => state.configSlice);
  const tagsData = useSelector((state) => state.tagsSlice);
  const userData = useSelector((state) => state.userSlice);
  const moduleData = useSelector((state) => state.moduleSlice);
  const [loading, setLoading] = useState(false);
  const [key, setKey] = useState(0);
  const [learningPoints, setLearningPoints] = useState([]);
  const [outcomesPoints, setOutcomesPoints] = useState([]);
  const [mediaGalleryShow, setMediaGalleryShow] = useState(false);
  const [allSavedFileUrl, setAllSavedFileUrl] = useState([]);
  const [uploadedProductFiles, setUploadedProductFiles] = useState([]);
  const [moduleThumbnailUrl, setModuleThumbnailUrl] = useState(null);
  const [thumbnailProgressBar, setThumbnailProgressBar] = useState(false);
  const [fileError, setFileError] = useState(null);
  const [validationError, setValidationError] = useState(false);
  const [moduleTitle, setModuleTitle] = useState("");
  const [description, setDescription] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [selectedSectors, setSelectedSectors] = useState(null);
  const [courseDuration, setCourseDuration] = useState("0");
  const [selectedPackages, setSelectedPackages] = useState(null);
  const [selectedValidate, setSelectedValidate] = useState([]);
  const [selectedJobRoles, setSelectedJobRoles] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState([]);
  const [selectedDifficulty, setSelectedDifficulty] = useState(null);
  const [assetsList, setAssetsList] = useState([]);
  const [threeDCategoryList, setThreeDCategoryList] = useState([]);
  const [hierarchyList, setHierarchyList] = useState([]);
  const [jobRolesTagsOptions, setJobRolesTagsOptions] = useState([]);
  const [selectPlatformList, setSelectedPlatformList] = useState([]);
  const [validateTagOptions, setValidateTagOptions] = useState([]);
  const [languageTagsOptions, setLanguageTagsOptions] = useState([]);
  const [tagsOptions, setTagsOptions] = useState([]);
  const [linkedAssetList, setLinkedAssetList] = useState([]);
  const [applicationTagsOptions, setApplicationTagsOptions] = useState([]);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [levelsTagsOptions, setLevelsTagsOptions] = useState([]);
  const [showLinkModel, setShowLinkModel] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [nodesList, setNodesList] = useState(null);

  const [packagesTagOptions, setPackagesTagOptions] = useState([]);
  const [sectorTagOptions, setSectorTagOptions] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [publishStatus, setPublishStatus] = useState(true);
  const [activeStatus, setActiveStatus] = useState(true);

  const [aboutProjectState, setAboutProjectState] = useState(EditorState.createEmpty());
  const { setPageTitle } = usePageTitle();

  useEffect(() => {
    setPageTitle("XR Modules");
    setUploadedProductFiles([]);
    setAllSavedFileUrl([]);

    if (actionMode === "REVIEW" && moduleData?.reviewModuleData?.basicDetail) {
      let _data = moduleTagCategoryWithTags();
      let reduxData = moduleData.reviewModuleData.basicDetail;
      setModuleTitle(reduxData.name);
      setPublishStatus(reduxData.publish)
      setSelectedCategory(reduxData.tagCategory[0]);
      setModuleThumbnailUrl(reduxData.data.thumbnail);
      setAllSavedFileUrl(reduxData.data.media);
      setShortDescription(reduxData.data.short);
      setLearningPoints(reduxData.data.learningPoints);
      setOutcomesPoints(reduxData.data.outcomesPoints);
      setCourseDuration(reduxData.data.courseDuration);
      setLinkedAssetList(reduxData.linkedAssets);
      setSelectedPlatformList(availablePlatformList.filter((e) => reduxData.platforms.includes(e.value)));

      const description = EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(reduxData.data?.description || ""))
      );
      setAboutProjectState(description);
      let _sector = _data._sectorsList.filter((e) => reduxData.tags.includes(e.value));
      setSelectedSectors(_sector.length === 0 ? null : _sector[0]);
      let _package = _data._packagesList.filter((e) => reduxData.tags.includes(e.value));
      setSelectedPackages(_package.length === 0 ? null : _package[0]);

      setSelectedJobRoles(_data._jobRolesTags.filter((e) => reduxData.tags.includes(e.value)));
      setSelectedTags(_data._Tags.filter((e) => reduxData.tags.includes(e.value)));
      setSelectedLanguage(_data._languagesTags.filter((e) => reduxData.tags.includes(e.value)));
      setSelectedValidate(_data._ValidatedByLevelTags.filter((e) => reduxData.tags.includes(e.value)));
      const selectLevel = _data._difficultyLevelTags.filter((e) => reduxData.tags.includes(e.value))[0]?.value || null;
      if (selectLevel) {
        setSelectedDifficulty(selectLevel);
      }
    }
  }, [moduleData]);

  const getCategoryList = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${CATEGORY_CHILDREN_LIST}/${CategoryFilterId}`);
      setCategoryList(data.children);
      let result = transformData(data.children);
      setNodesList(result);
    } catch (error) {
      console.error(error);
    }
  };

  const getResourceTypeApplication = async () => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${RESOURCE_TYPE_APPLICATION}/MODULE`);
      let list = data.list.map((e) => {
        return {
          icon: e.icon,
          label: e.name,
          value: e.uuid,
        };
      });
      setApplicationTagsOptions(list);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    AOS.init();
    AOS.refresh();
    getCategoryList();
    getResourceTypeApplication();
  }, []);

  const addLearningPointer = () => {
    setLearningPoints((prevPoints) => [...prevPoints, ""]);
  };

  const addOutcomesPointer = () => {
    setOutcomesPoints((prevPoints) => [...prevPoints, ""]);
  };

  const deleteOutcomesPointer = (index) => {
    var newPoints = [...outcomesPoints];
    newPoints.splice(index, 1);
    setOutcomesPoints(newPoints);
  };

  const deleteLearningPointer = (index) => {
    var newPoints = [...learningPoints];
    newPoints.splice(index, 1);
    setLearningPoints(newPoints);
  };

  const handleOutcomesPointChange = (event, index) => {
    var points = [...outcomesPoints];
    points[index] = event.target.value;
    setOutcomesPoints(points);
  };

  const handleLearningPointChange = (event, index) => {
    var points = [...learningPoints];
    points[index] = event.target.value;
    setLearningPoints(points);
  };

  const getModuleDetail = async () => {
    try {
      let _data = moduleTagCategoryWithTags();
      let moduleData = await apiClient.get(`${configData.config.UNO_URL}${XR_MODULE_DETAIL}/${moduleUUID}`);

      let connectedApplication = moduleData.applications.map((e) => {
        return {
          icon: e.icon,
          label: e.name,
          value: e.uuid,
        };
      });

      setSelectedApplications(connectedApplication);
      setModuleTitle(moduleData?.name);
      setPublishStatus(moduleData.publish);
      setActiveStatus(moduleData.active);
      setModuleThumbnailUrl(moduleData?.versions[0]?.data?.thumbnail);
      setDescription(moduleData?.versions[0]?.data?.description);

      setAllSavedFileUrl(moduleData?.versions[0]?.data?.media || []);
      setLearningPoints(moduleData?.versions[0]?.data?.learningPoints || []);
      setOutcomesPoints(moduleData?.versions[0]?.data?.outcomesPoints || []);
      setShortDescription(moduleData?.versions[0]?.data?.short);
      setCourseDuration(moduleData?.versions[0]?.data?.courseDuration || "0");

      let connectedTagCategoryId = moduleData.tagCategory.length > 0 ? moduleData.tagCategory[0].id : null;
      setSelectedCategory(connectedTagCategoryId);

      let moduleTags = moduleData?.tags?.map((item) => ({
        value: item.id,
        label: item.name,
        categoryId: item.categoryId,
      }));

      setSelectedTags(
        moduleTags.filter((e) => e?.categoryId === _data?.categories.filter((cat) => cat?.name === "Tags")[0]?.id)
      );
      setSelectedSectors(
        moduleTags.filter((e) => e?.categoryId === _data?.categories.filter((cat) => cat?.name === "Sectors")[0]?.id)[0]
      );
      setSelectedPackages(
        moduleTags.filter(
          (e) => e?.categoryId === _data?.categories.filter((cat) => cat?.name === "Packages")[0]?.id
        )[0]
      );
      setSelectedJobRoles(
        moduleTags.filter((e) => e?.categoryId === _data?.categories.filter((cat) => cat?.name === "Job Roles")[0]?.id)
      );
      setSelectedValidate(
        moduleTags.filter(
          (e) => e?.categoryId === _data?.categories.filter((cat) => cat?.name === "Validated By")[0]?.id
        )[0]
      );
      setSelectedLanguage(
        moduleTags.filter((e) => e?.categoryId === _data?.categories.filter((cat) => cat?.name === "Languages")[0]?.id)
      );
      const selectLevel =
        moduleTags.filter(
          (e) => e?.categoryId === _data?.categories.filter((cat) => cat?.name === "Difficulty Level")[0]?.id
        )[0]?.value || null;
      if (selectLevel) {
        setSelectedDifficulty(selectLevel);
      }
      const description = EditorState.createWithContent(
        ContentState.createFromBlockArray(convertFromHTML(moduleData?.versions[0].data?.description || ""))
      );
      setAboutProjectState(description);
    } catch (error) {
      console.log(error);
    }
  };

  const getLinkedAssetList = async () => {
    try {
      let list = await apiClient.get(`${configData.config.UNO_URL}${LINKED_ASSET_LIST}/${moduleUUID}`);

      let linkedResource = list.linkedResources.map((item) => ({
        name: item.name,
        uuid: item.uuid,
      }));

      setLinkedAssetList(linkedResource);
    } catch (error) {
      console.log(error);
    }
  };

  const handleConnect3DAsset = async () => {
    try {
      let _bodyData = {
        ids: linkedAssetList.map((e) => e.uuid),
      };

      await apiClient.post(`${configData.config.UNO_URL}${CONNECT_ASSETS}/${moduleUUID}`, _bodyData);
      getLinkedAssetList();
    } catch (error) {
      console.log(error);
    }
  };

  const getCategoryAssetList = async (id) => {
    try {
      let data = await apiClient.get(`${configData.config.UNO_URL}${CATEGORY_ASSETS_LIST}/${id}`);
      setAssetsList(data);
    } catch (error) {
      console.log(error);
    }
  };

  const get3DAssetsCategoryList = async (id) => {
    let data = await apiClient.get(`${configData.config.UNO_URL}${CATEGORY_CHILDREN_LIST}/${id}`);
    setThreeDCategoryList(data.children);
    setHierarchyList(data.heirarchy);
  };

  useEffect(() => {
    getCategoryAssetList(configData.config["3dAssetsId"]);
    get3DAssetsCategoryList(configData.config["3dAssetsId"]);
  }, [configData.config["3dAssetsId"]]);

  const handleSelectLinkedResource = async (data) => {
    let list = [...linkedAssetList];
    const index = list.findIndex((el) => el.uuid === data.uuid);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(data);
    }
    setLinkedAssetList(list);
  };

  const handleCloseLinkModal = async (value) => {
    if (!value) {
      getCategoryAssetList(configData.config["3dAssetsId"]);
      get3DAssetsCategoryList(configData.config["3dAssetsId"]);
    }
    setShowLinkModel(false);
  };

  const getAllModuleData = () => {
    let _data = moduleTagCategoryWithTags();
    if (actionMode === "XR") {
      setSelectedDifficulty(_data?._difficultyLevelTags[1].value || null);
    }
    setSectorTagOptions(_data?._sectorsList);
    setPackagesTagOptions(_data?._packagesList);
    setJobRolesTagsOptions(_data?._jobRolesTags);
    setLanguageTagsOptions(_data?._languagesTags);
    setValidateTagOptions(_data?._ValidatedByLevelTags);
    setLevelsTagsOptions(_data?._difficultyLevelTags);
    setTagsOptions(_data?._Tags);
    if (actionMode === "XR") {
      getLinkedAssetList();
    }
    if (!moduleData?.reviewModuleData?.basicDetail) {
      getModuleDetail();
    }
  };

  useEffect(() => {
    if (moduleUUID.length > 0 && tagsData?.allTagsList?.name) {
      getAllModuleData();
    }
  }, [moduleUUID, tagsData]);

  const handleHandoverAboutChangeInput = (event) => {
    setAboutProjectState(event);
    setDescription("" + draftToHtml(convertToRaw(event.getCurrentContent())));
  };

  const removeThumbnail = () => {
    setModuleThumbnailUrl(null);
    setFileError(null);
  };

  const uploadThumbnailImage = async (file) => {
    setFileError(null);
    setModuleThumbnailUrl(null);

    if (isFileSizeOverMaxSize(file.size, MODULE_THUMBNAIL_SIZE)) {
      let _error = `File Size is more then ${getAllowedMaxFileSize(MODULE_THUMBNAIL_SIZE)}`
      setKey((pre) => pre + 1);
      setFileError(_error);
      toastError(_error);
      return;
    }

    let passStatus = await verifyImageResolution(file);
    if (!passStatus) {
      setKey((pre) => pre + 1);
      return;
    }

    try {


      setThumbnailProgressBar(true);
      const formData = new FormData();
      formData.append("file", file);

      axios
        .post(`${configData.config.UNO_URL}/api/resource/upload/thumbnail/${moduleUUID}`, formData, {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
            "Content-Type ": "multipart/form-data",
          },
        })
        .then((res) => {
          setModuleThumbnailUrl(res?.data?.url);
          setThumbnailProgressBar(false);
        })
        .catch((err) => {
          setModuleThumbnailUrl(null);
          console.log(err);
        });
    } catch (error) {
      console.log(error);
      setKey((pre) => pre + 1);
    } finally {
      setTimeout(() => {
        setFileError(null);
      }, 3500);
    }
  };

  const checkValidation = () => {
    let errorStatus = false;
    setValidationError(false);

    if (moduleTitle.trim().length === 0) {
      errorStatus = true;
      setValidationError(true);
    }
    if (!moduleThumbnailUrl) {
      errorStatus = true;
      setValidationError(true);
    }

    // if (!selectedSectors) {
    //   errorStatus = true;
    //   setValidationError(true);
    // }
    // if (!selectedPackages) {
    //   errorStatus = true;
    //   setValidationError(true);
    // }

    if (!selectedDifficulty) {
      errorStatus = true;
      setValidationError(true);
    }
    // if (!selectedCategory) {
    //   errorStatus = true;
    //   setValidationError(true);
    // }
    if (courseDuration.trim().length == 0) {
      errorStatus = true;
      setValidationError(true);
    }

    if (actionMode === "REVIEW" && selectPlatformList.length === 0) {
      errorStatus = true;
      setValidationError(true);
    }

    setTimeout(() => {
      setValidationError(false);
    }, 3500);
    return errorStatus;
  };

  const isTagEmpty = (htmlString) => {
    const emptyTagRegex = /<(\w+)[^>]*>(\s|&nbsp;|<br\s*\/?>)*<\/\1>/gi;
    return emptyTagRegex.test(htmlString);
  };

  const validPayload = () => {
    let errorStatus = false;
    if (!moduleTitle?.trim()) errorStatus = true;
    if (!moduleThumbnailUrl) errorStatus = true;
    if (!selectedJobRoles || !selectedJobRoles?.length) errorStatus = true;
    if (!shortDescription?.trim()) errorStatus = true;
    if (!selectedLanguage || !selectedLanguage?.length) errorStatus = true;
    if (!String(courseDuration)) errorStatus = true;
    if (!selectedTags || !selectedTags?.length) errorStatus = true;
    if (!selectedValidate) errorStatus = true;
    if (!selectedCategory) errorStatus = true;
    if (!selectedApplications || !selectedApplications?.length) errorStatus = true;
    // if (isTagEmpty(description?.trim())) errorStatus = true;
    return errorStatus;
  };

  let collectFormsData = () => {
    let allTagsList = [];
    let moduleActiveStatus = false;

    if (selectedSectors?.value) {
      allTagsList.push(Number(selectedSectors.value));
    }
    if (selectedPackages?.value) {
      allTagsList.push(Number(selectedPackages.value));
    }

    if (selectedValidate?.value) {
      allTagsList.push(Number(selectedValidate.value));
    }

    selectedTags?.map((e) => {
      return allTagsList.push(Number(e?.value));
    });

    selectedJobRoles?.map((e) => {
      return allTagsList.push(Number(e?.value));
    });

    selectedLanguage?.map((e) => {
      return allTagsList.push(Number(e?.value));
    });

    if (selectedDifficulty) {
      allTagsList.push(Number(selectedDifficulty));
    }

    if (
      moduleThumbnailUrl &&
      moduleTitle &&
      selectedTags.length &&
      selectedValidate.length &&
      selectedJobRoles.length &&
      selectedLanguage.length &&
      selectedDifficulty.length &&
      description?.length >= 25 &&
      shortDescription?.length &&
      courseDuration &&
      selectedCategory &&
      learningPoints.length &&
      outcomesPoints.length
    ) {
      moduleActiveStatus = true;
    }
    return {
      name: moduleTitle,
      publish: publishStatus,
      active: activeStatus,
      tags: [...allTagsList],
      tagCategory: selectedCategory ? [selectedCategory] : [],
      applicationsIds: selectedApplications.map((e) => e.value),
      data: {
        thumbnail: moduleThumbnailUrl,
        media: allSavedFileUrl,
        short: shortDescription,
        description: description,
        courseDuration: courseDuration,
        learningPoints: learningPoints,
        outcomesPoints: outcomesPoints,
      }
    };
  };

  const handleUpdateModuleDetails = async () => {
    try {
      if (validPayload()) {
        setValidationError(true);
        setTimeout(() => {
          setValidationError(false);
        }, 3500);
        return;
      }
      let data = collectFormsData();
      handleConnect3DAsset();
      await axios.post(`${configData.config.UNO_URL}${XR_MODULE_DETAIL}/${moduleUUID}`, data, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleProductImageChange = (files) => {
    const filteredFiles = Array.from(files);

    const imageFiles = [];
    const videoFiles = [];

    filteredFiles.forEach((file) => {
      if (file.type.startsWith("image/") && !isFileSizeOverMaxSize(file.size, MODULE_MEDIA_SIZE ) ) {
        imageFiles.push(file);
      } else if (file.type.startsWith("video/")) {
        videoFiles.push(file);
      }
    });

    const updatedFiles = [...imageFiles, ...videoFiles].map((file) => ({
      file,
      progress: 0,
    }));

    setUploadedProductFiles([...uploadedProductFiles, ...updatedFiles]);

    updatedFiles.forEach((file) => {
      uploadFile(file.file);
    });
  };

  const uploadFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await axios.post(
        `${configData.config.UNO_URL}/api/resource/upload/media/${moduleUUID}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
            "Content-Type ": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const progress = (progressEvent.loaded / progressEvent.total) * 100;
            updateFileProgress(file, Math.floor(progress));
          },
        }
      );

      updateFileProgress(file, 100, response?.data?.url);
    } catch (error) {
      console.error(error);
    }
  };

  const updateFileProgress = (file, progress, url = null) => {
    setUploadedProductFiles((prevFiles) =>
      prevFiles.map((upload) => {
        if (upload.file === file) {
          return { ...upload, progress, url };
        }
        return upload;
      })
    );
  };

  const saveProductImagesFile = async () => {
    let allFileArray = [...allSavedFileUrl, ...uploadedProductFiles].map(({ url }) => ({ url }));
    setAllSavedFileUrl(allFileArray);
    setUploadedProductFiles([]);
    GalleryClose();
  };

  const deleteProductImage = (type, url) => {
    if (type === "allSavedFileUrl") {
      const filteredData = allSavedFileUrl.filter((obj) => obj.url !== url);
      setAllSavedFileUrl(filteredData);
    } else if (type === "uploadedProductFiles") {
      const filteredData = uploadedProductFiles.filter((obj) => obj.url !== url);
      setUploadedProductFiles(filteredData);
    }
  };

  const handleNextTabToJump = () => {
    if (checkValidation()) {
      toastError("Kindly fill all * field");
      return;
    }

    let data = collectFormsData();
    data["linkedAssets"] = linkedAssetList;
    data["platforms"] = selectPlatformList.map((e) => e.value);
    dispatch(addReviewModuleData({ basicDetail: data }));
    navigate(`/dashboard/xr/review/assets/${moduleUUID}`, {
      state: { name: moduleTitle, type: "MODULE", actionMode: actionMode },
    });
  };

  const GalleryClose = () => setMediaGalleryShow(false);
  const GalleryShow = () => setMediaGalleryShow(true);

  const handleChangeLevel = (level) => {
    setSelectedDifficulty(level);
  };

  const debounceHandleSaveReview = debounce(handleUpdateModuleDetails, 1000, setLoading);

  return (
    <>
      <div className="detailspage xrmoduledetail container-fluid" data-aos="fade-left">
        <div className="mainbox">
          <div className="row">
            <div className="col-md-4">
              <div className="row">
                <div className="col p-0">
                  {thumbnailProgressBar ? (
                    <div className="uploadProgressBar">
                      <div className="progress mt-2" style={{ height: "10px" }}>
                        <div
                          className="progress-bar progress-bar-striped progress-bar-animated bg-danger"
                          role="progressbar"
                          aria-valuenow="75"
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{ width: "100%", height: "10px" }}
                        ></div>
                      </div>
                      <p>
                        Uploading<span className="dot-animation"></span>
                      </p>
                    </div>
                  ) : (
                    <div className="modulepic justify-content-start">
                      <div className="thumbnailImageDiv ps-3">
                        {moduleThumbnailUrl?.length > 0 ? (
                          <div>
                            <img id="thumbnailImage" src={moduleThumbnailUrl} alt="Uploaded Thumbnail" />
                            <span className="canceldelete" onClick={removeThumbnail}>
                              X
                            </span>
                          </div>
                        ) : (
                          <div className="fileuploader">
                            <FileUploader
                              key={key}
                              handleChange={uploadThumbnailImage}
                              name="thumbnailInput"
                              types={imageFileTypes}
                              label="drag & drop or choose file to upload"
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                <div className="col imgupload">
                  <label className="mb-1">
                    Thumbnail Image <span> * </span>
                  </label>
                  <p className="recommend">Max file size: {getAllowedMaxFileSize(MODULE_THUMBNAIL_SIZE)} </p>
                  <p className="recommend">Required Resolution* (1280px &times; 720px)</p>
                  <p className="fileError">{fileError}</p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="row">
                <div className="col">
                  <div className="modulepic justify-content-start">
                    <button onClick={GalleryShow} className="productpopup">
                      <GalleryIcon />
                      <p>Choose files to upload</p>
                    </button>
                  </div>
                </div>
                <div className="col p-0">
                  <label className="mb-2">Media Gallery</label>
                  {allSavedFileUrl?.length > 0 && (
                    <p className="fileSuccess hoverCursor" onClick={GalleryShow}>
                      {" "}
                      0{allSavedFileUrl.length} Files Uploaded
                    </p>
                  )}
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <QRExpand uuid={moduleUUID} />
            </div>

            <div className="col-md-4 mt-3">
              <div className="form-group">
                <label htmlFor="exampleFormControlInput1">
                  Course Name <span>*</span>
                </label>
                <input
                  type="text"
                  value={moduleTitle}
                  onChange={(e) => setModuleTitle(e.target.value)}
                  className="form-control mt-2"
                  id="exampleFormControlInput1"
                  placeholder="Enter course name"
                />
              </div>
            </div>

            <div className="col-md-4 mt-3">
              <div className="form-group">
                <label className="form-label">
                  Level <span> * </span>
                </label>
                <FormControl fullWidth className="mb-0 mt-2 pt-0 d-flex align-items-start">
                  <RadioGroup
                    row
                    aria-labelledby="price-visibility-label"
                    name="questionType"
                    className="gap-3"
                    value={selectedDifficulty}
                    onChange={(e) => handleChangeLevel(e.target.value)}
                  >
                    {levelsTagsOptions.length > 0 &&
                      levelsTagsOptions.map((level, index) => {
                        return (
                          <FormControlLabel
                            key={index}
                            className="quizlabel"
                            value={level?.value}
                            control={<Radio />}
                            label={level.label}
                          />
                        );
                      })}
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            {/* <div className="col-md-4 mt-2">
              <div className="form-group">
                <label htmlFor="exampleFormControlInput1">Sectors  <span>*</span></label>
                <Select
                  name="sectors"
                  className="basic-multi-select mt-2"
                  classNamePrefix="select"
                  placeholder="Select Sectors"
                  options={sectorTagOptions}
                  value={selectedSectors}
                  onChange={setSelectedSectors}
                  components={{ NoOptionsMessage: (props) => createNewCustomTags({ ...props, customName: "Sectors" }) }}
                  filterOption={(option, inputValue) =>
                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                  }
                />
              </div>
            </div> */}

            <div className="col-md-4 mt-3">
              <div className="form-group">
                <label htmlFor="exampleFormControlInput1">
                  Job Roles <span>*</span>
                </label>
                <Select
                  isMulti
                  name="jobRoles"
                  className="basic-multi-select mt-2"
                  classNamePrefix="select"
                  placeholder="Select Job Roles"
                  options={jobRolesTagsOptions}
                  value={selectedJobRoles}
                  onChange={setSelectedJobRoles}
                  components={{
                    NoOptionsMessage: (props) => createNewCustomTags({ ...props, customName: "Job Roles" }),
                  }}
                  filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                />
              </div>
            </div>

            {/* <div className="col-md-4 mt-2">
              <div className="form-group">
                <div>
                  <label htmlFor="exampleFormControlInput1">Package  <span>*</span></label>
                  <Select
                    name="Packages"
                    className="basic-multi-select mt-2"
                    classNamePrefix="select"
                    placeholder="Select Sectors"
                    options={packagesTagOptions}
                    value={selectedPackages}
                    onChange={setSelectedPackages}
                    components={{ NoOptionsMessage: (props) => createNewCustomTags({ ...props, customName: "Packages" }) }}
                    filterOption={(option, inputValue) =>
                      option.label.toLowerCase().includes(inputValue.toLowerCase())
                    }
                  />
                </div>
              </div>
            </div> */}

            <div className="col-md-4">
              <div className="form-group pt-3">
                <label htmlFor="exampleFormControlShortDesc" className="form-label">
                  Short Description <span>*</span>
                </label>
                <input
                  value={shortDescription}
                  onChange={(e) => setShortDescription(e.target.value)}
                  placeholder="Short Description"
                  className="form-control mt-2"
                  id="exampleFormControlShortDesc"
                />
              </div>
            </div>

            {actionMode === "REVIEW" && (
              <div className="col-md-4">
                <div className="form-group pt-3">
                  <label htmlFor="exampleFormControlInput1">
                    Available Platforms <span>*</span>
                  </label>
                  <Select
                    isMulti
                    name="jobRoles"
                    className="basic-multi-select mt-2"
                    classNamePrefix="select"
                    placeholder="Select Job Roles"
                    options={availablePlatformList}
                    value={selectPlatformList}
                    onChange={setSelectedPlatformList}
                    filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                  />
                </div>
              </div>
            )}

            <div className="col-md-4">
              <div className="form-group pt-3">
                <label htmlFor="exampleFormControlInput1">
                  Language <span>*</span>
                </label>
                <Select
                  isMulti
                  name="Language"
                  className="basic-multi-select mt-2"
                  classNamePrefix="select"
                  placeholder="Select Language"
                  options={languageTagsOptions}
                  value={selectedLanguage}
                  onChange={setSelectedLanguage}
                  filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group pt-3 mt-0">
                <label htmlFor="exampleFormControlInput1">
                  Course Duration <span>*</span>
                </label>
                <div className="pointer-list">
                  <input
                    type="number"
                    value={courseDuration}
                    onChange={(e) => setCourseDuration(e.target.value)}
                    placeholder="Enter time in minutes"
                    className="form-control mt-2"
                    id="exampleFormControlShortDesc"
                  />
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group pt-3 mt-0">
                <label htmlFor="exampleFormControlInput1">
                  Tags <span>*</span>
                </label>
                <Select
                  isMulti
                  name="Tags"
                  className="basic-multi-select mt-2"
                  classNamePrefix="select"
                  placeholder="Select Tags"
                  options={tagsOptions}
                  value={selectedTags}
                  onChange={setSelectedTags}
                  components={{ NoOptionsMessage: (props) => createNewCustomTags({ ...props, customName: "Tags" }) }}
                  filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group pt-3 mt-0">
                <label htmlFor="exampleFormControlInput1">
                  Validated By <span>*</span>
                </label>
                <Select
                  // isMulti
                  name="ValidatedBy"
                  className="basic-multi-select mt-2"
                  classNamePrefix="select"
                  placeholder="Select Language"
                  options={validateTagOptions}
                  value={selectedValidate}
                  onChange={setSelectedValidate}
                  createNewCustomTags
                  components={{
                    NoOptionsMessage: (props) => createNewCustomTags({ ...props, customName: "Validated By" }),
                  }}
                  filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                />
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group pt-3 mt-0">
                <label htmlFor="exampleFormControlInput1">
                  Select Category <span>*</span>
                </label>
                <TreeSelect
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.value)}
                  options={nodesList}
                  metaKeySelection={false}
                  filter
                  className="w-100 mt-2"
                  placeholder="Select Category"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="col-12">

                <div className="form-group pt-3 mt-0">
                  <label htmlFor="exampleFormControlInput1">
                    Select Application <span>*</span>
                  </label>
                  <Select
                    isMulti
                    name="applications"
                    className="basic-multi-select mt-2"
                    classNamePrefix="select"
                    placeholder="Select Applications"
                    options={applicationTagsOptions}
                    value={selectedApplications}
                    onChange={setSelectedApplications}
                    filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                  />
                </div>
              </div>
              <div className="col-12">
                <div className="form-group pt-3 mt-0">
                  <label>
                    Active Status
                  </label>
                  <div className="checkbox-wrapper-8 mt-2">
                    <input
                      type="checkbox"
                      id="formControlInputActive"
                      className="tgl tgl-skewed"
                      checked={activeStatus}
                      onChange={() => setActiveStatus(pre => !pre)}
                    />
                    <label
                      htmlFor="formControlInputActive"
                      data-tg-on="Active"
                      data-tg-off="Inactive"
                      className="tgl-btn" />
                  </div>
                </div>
              </div>
              <div className="col-12">

                <div className="form-group pt-3 mt-0">
                  <label>
                    Publish Status
                  </label>
                  <div className="checkbox-wrapper-8 mt-2">
                    <input
                      type="checkbox"
                      id="formControlInputPublish"
                      className="tgl tgl-skewed"
                      checked={publishStatus}
                      onChange={() => setPublishStatus(pre => !pre)}
                    />

                    <label
                      htmlFor="formControlInputPublish"
                      data-tg-on="Active"
                      data-tg-off="Inactive"
                      className="tgl-btn" />
                  </div>
                </div>
              </div>

            </div>

            {/* {actionMode !== "REVIEW" && <div className="col-md-4"> {""} </div>} */}

            <div className="col-md-8">
              <div className="form-group pt-3">
                <label htmlFor="exampleFormControlDescription" className="form-label">
                  Description <span>*</span>
                </label>
                <div className="modalDescription">
                  <Editor
                    name="project_about"
                    id="exampleFormControlDescription"
                    editorState={aboutProjectState}
                    stripPastedStyles={true}
                    wrapperClassName="demo-wrapper"
                    className="mt-2"
                    editorClassName="demo-editor"
                    onEditorStateChange={handleHandoverAboutChangeInput}
                    toolbar={{
                      options: ["inline", "remove", "history"],
                      inline: {
                        inDropdown: false,
                        options: ["bold", "italic", "underline", "strikethrough"],
                      },
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group pt-3 mt-1">
                <label htmlFor="exampleFormControlInput1">What you will learn ?</label>
                <div className="pointer-list">
                  {learningPoints?.map((point, index) => (
                    <span key={index} className="pointer-here">
                      <input
                        placeholder={`Point number : ${index + 1}`}
                        className="form-control mt-1"
                        id="exampleFormControlShortDesc"
                        value={point}
                        onChange={(event) => handleLearningPointChange(event, index)}
                      />
                      <button className="delete-point" onClick={() => deleteLearningPointer(index)}>
                        <DeleteIcon />
                      </button>
                    </span>
                  ))}
                  <button className="addpoint" onClick={addLearningPointer}>
                    <AddIcon />
                    Add
                  </button>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="form-group pt-3 mt-1">
                <label htmlFor="exampleFormControlInput1">Outcomes :</label>
                <div className="pointer-list">
                  {outcomesPoints?.map((point, index) => (
                    <span key={index} className="pointer-here">
                      <input
                        placeholder={`Point number : ${index + 1}`}
                        className="form-control mt-1"
                        id="exampleFormControlShortDesc"
                        value={point}
                        onChange={(event) => handleOutcomesPointChange(event, index)}
                      />
                      <button className="delete-point" onClick={() => deleteOutcomesPointer(index)}>
                        <DeleteIcon />
                      </button>
                    </span>
                  ))}
                  <button className="addpoint" onClick={addOutcomesPointer}>
                    <AddIcon />
                    Add
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group forthreed pt-3">
                <label htmlFor="exampleFormControlDescription" className="form-label">
                  3D Models
                </label>
                <div className="threeD-model-list">
                  {linkedAssetList.map((item, index) => (
                    <div className="model-item">
                      <p> {item.name} </p>
                      <button className="delete-point" onClick={() => handleSelectLinkedResource(item)}>
                        <DeleteIcon />
                      </button>
                    </div>
                  ))}
                </div>
                <button className="addpoint" onClick={() => setShowLinkModel(true)}>
                  <AddIcon />
                  Add
                </button>
              </div>
            </div>

            <div className="col-md-8">
              <div className="row"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-md-12 pe-2 mt-4">
        <div className="footerbtn text-end">
          {validationError && <p className="basicDetailError"> Kindly fill all * field </p>}
        </div>
        <div className="footerbtn text-end">
          <button onClick={() => navigate("/dashboard/xr")}>Cancel</button>

          {actionMode === "XR" ? (
            <button onClick={debounceHandleSaveReview}>{loading ? <BtnLoading /> : "Save & Submit"}</button>
          ) : (
            <button onClick={handleNextTabToJump}>Next</button>
          )}
        </div>
      </div>

      {mediaGalleryShow && (
        <MediaGalleryModal
          maxFileSize={MODULE_MEDIA_SIZE[VALUE] }
          mediaGalleryShow={mediaGalleryShow}
          GalleryClose={GalleryClose}
          fileTypes={imageFileTypes}
          handleProductImageChange={handleProductImageChange}
          allSavedFileUrl={allSavedFileUrl}
          deleteProductImage={deleteProductImage}
          uploadedProductFiles={uploadedProductFiles}
          saveProductImagesFile={saveProductImagesFile}
        />
      )}
      {showLinkModel && (
        <LinkModal
          moduleTitle={moduleTitle}
          showLinkModel={showLinkModel}
          handleCloseLinkModal={(value) => handleCloseLinkModal(value)}
          assetsList={assetsList}
          threeDCategoryList={threeDCategoryList}
          hierarchyList={hierarchyList}
          get3DAssetsCategoryList={get3DAssetsCategoryList}
          getCategoryAssetList={getCategoryAssetList}
          linkedAssetList={linkedAssetList}
          handleSelectLinkedResource={setLinkedAssetList}
        />
      )}
    </>
  );
};

export default Details;
